import { Action } from 'redux';

import { OpenConnectedApplicationDialog } from '~src/app/actions/AppActionTypes';
import { IDeleteAction } from '~src/ts/ServerApi/types/actionNames';

import { EntityActionNames, IEntityAction } from '../../app/spaces/ActionsMenu/EntityActions/IEntityAction';
import { Messages } from '../../codegen/Localize';
import { IConnectedApplicationInfo } from '../models/ConnectedApplicationInfo';

export interface IConnectedApplicationMenuAction extends Action {
  items: IConnectedApplicationInfo[];
}

// Type is only used by generic infra and as such does not need to know of the other valid action types
export type ConnectedApplicationMenuActions = Readonly<
  IDeleteAction
>;

export interface OpenConnectedApplicationDialogAction extends Action {
  previous?: IConnectedApplicationInfo;
}

export function createNewConnectedApplication(): OpenConnectedApplicationDialogAction {
  return {
    type: OpenConnectedApplicationDialog
  };
}

export function editConnectedApplication(application: IConnectedApplicationInfo): OpenConnectedApplicationDialogAction {
  return {
    type: OpenConnectedApplicationDialog,
    previous: application,
  };
}


export const ConnectedApplicationEditAction: IEntityAction<IConnectedApplicationInfo, {}> = {
  name: EntityActionNames.Edit,
  translateName: Messages.connectedApplicationsEditConnectedAppMenu,
  isVisible: () => true,
  isClickable: (_: {}, items: IConnectedApplicationInfo[]) => items.length === 1,
  createReduxAction: items => editConnectedApplication(items[0]),
};

